import * as yup from 'yup';

function name(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'NAME_FIELD_IS_REQUIRED',
      defaultMessage: 'Company Name is required',
    }),
  );
}

function accountNumber(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'ACCOUNTNUMBER_FIELD_IS_REQUIRED',
      defaultMessage: 'Account Number is required',
    }),
  );
}

function contactFirstName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CONTACTNAME_FIRST_FIELD_IS_REQUIRED',
      defaultMessage: 'First Name is required',
    }),
  );
}

function contactLastName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CONTACTNAME_LAST_FIELD_IS_REQUIRED',
      defaultMessage: 'Last Name is required',
    }),
  );
}

function contactEmail(formatMessage) {
  return yup
    .string()
    .email(
      formatMessage({
        id: 'CONTACTEMAIL_FIELD_FORMAT_EMAIL',
        defaultMessage: 'Contact Email must be a valid email address',
      }),
    )
    .required(
      formatMessage({
        id: 'CONTACTEMAIL_FIELD_IS_REQUIRED',
        defaultMessage: 'Contact Email is required',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'STATUS_FIELD_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

function fein(formatMessage) {
  return yup
    .string()
    .nullable()
    .max(
      12,
      formatMessage({
        id: 'FEIN_FIELD_MAX_LENGTH',
        defaultMessage: 'FEIN must be at most 12 characters',
      }),
    )
    .test(
      'fein-9-digits',
      formatMessage({
        id: 'FEIN_FIELD_9_DIGITS',
        defaultMessage: 'FEIN must be exactly 9 digits',
      }),
      value => {
        if (!value) return true;
        const digits = value.replace(/-/g, '');
        return /^\d{9}$/.test(digits);
      },
    );
}

function websiteUrl(formatMessage) {
  return yup
    .string()
    .nullable()
    .url(
      formatMessage({
        id: 'WEBSITEURL_FIELD_FORMAT_URL',
        defaultMessage:
          'Website URL must start with http:// or https:// and be a valid URL',
      }),
    )
    .max(
      124,
      formatMessage({
        id: 'WEBSITEURL_FIELD_MAX_LENGTH',
        defaultMessage: 'Website URL must be at most 124 characters',
      }),
    );
}

function bmsSystem(formatMessage) {
  return yup
    .string()
    .nullable()
    .max(
      64,
      formatMessage({
        id: 'BMSSYSTEM_FIELD_MAX_LENGTH',
        defaultMessage: 'BMS System must be at most 64 characters',
      }),
    );
}

function defaultServiceTravelDistance(formatMessage, dispatchPurchased) {
  return yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .test(
      'required-if-dispatch-purchased',
      formatMessage({
        id: 'DEFAULT_SERVICE_TRAVEL_FIELD_IS_REQUIRED',
        defaultMessage: 'Default Service Travel Distance is required',
      }),
      value => {
        if (!dispatchPurchased) return true;
        return value !== null && value > 0;
      },
    );
}

const validationSchema = (formatMessage, getApiUrl, get, dispatchPurchased) =>
  yup
    .object({
      name: name(formatMessage, getApiUrl, get),
      accountNumber: accountNumber(formatMessage, getApiUrl, get),
      contactFirstName: contactFirstName(formatMessage),
      contactLastName: contactLastName(formatMessage),
      contactEmail: contactEmail(formatMessage),
      status: status(formatMessage),
      fein: fein(formatMessage),
      websiteUrl: websiteUrl(formatMessage),
      bmsSystem: bmsSystem(formatMessage),
      defaultServiceTravelDistance: defaultServiceTravelDistance(
        formatMessage,
        dispatchPurchased,
      ),
    })
    .required();

export default validationSchema;
